import appStation from "../../views/appRoutes/station.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("station", {
    url: "station/:id",
    parent: "app",
    views: {
      view: {
        template: appStation,
      },
    },
    data: { title: "Station" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/station/station.urls.js